export default "__VITE_ASSET__Bmqk2tPa__"